
import { ProfileTranslationType } from "../../features/profile.types";

export const profile: ProfileTranslationType = {
  profile: {
    title: "Profil",
    dangerZone: "Gefahrenbereich",
    deleteAccount: "Konto löschen",
    confirmDelete: "Löschen bestätigen",
    deleteWarning: "Sind Sie sicher, dass Sie Ihr Konto löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    confirmDeleteButton: "Konto löschen",
    accountDeleted: "Konto gelöscht",
    accountDeletedMessage: "Ihr Konto wurde erfolgreich gelöscht."
  },
  common: {
    cancel: "Abbrechen",
    delete: "Löschen",
    deleteConfirmation: "Löschen bestätigen",
    deleteConfirmationMessage: "Sind Sie sicher, dass Sie löschen möchten"
  }
};
